export { default } from "./dynamic-form";
export type { IOwnProps as IDynamicFormProps, IFormValues, IOnSubmitDynamicForm } from "./dynamic-form.types";
